const config = {
  configEndpoints: {
    baseEndpoint: "https://api.uat.hub.affinity.io",
  },
  configGoogleTagManager: {
    gtmId: "GTM-NL6LH2C",
  },
  configIntercom: {
    enabled: true,
  },
  configLiveChat: {
    script: "//js.hs-scripts.com/8487018.js?businessUnitId=108691",
  },
  configLogicMonitor: {
    baseUrl: "https://dc.api.masro.io/uat",
    jsBundleUrl: "https://s3.eu-west-2.amazonaws.com/dc.masro.io/js/logicone.js",
  },
};

export default config;
